export default __webpack_public_path__ + "static/media/question.04d461b9.png";